<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{ this.$route.name }}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-md-4">
            <table>
              <tr>
                <td>
                  <a @click="exportClass()" class="btn-primary mr-5"><i class="far fa-file-alt mr-5"></i>Export</a>
                </td>
                <td>
                  <flat-pickr :config="exportConfig" @on-change="changeDateBooking" v-model="exportDates"
                    name="export_date_start" class="font-13"></flat-pickr>
                </td>
              </tr>
            </table>
          </div>
          <div class="col-sm-4">
            <div class="row">
              <div class="col-sm-4 col-form-label text-right">
                Branch
              </div>
              <div class="col-sm-8">
                <b-form-select name="branch" v-model="branch_id" @change="changeBranch">
                  <option :value="null">Please select</option>
                  <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{ item.name }}</option>
                </b-form-select>
              </div>
            </div>
          </div>
          <div class="col-md-4 text-right">
            <div class="search-header">
              <div class="custom-search-container">
                <div class="input-group custom-search">
                  <input type="text" @keyup.enter="enterClicked(searchData)" v-model="searchData" class="form-control"
                    placeholder="Search">
                  <span class="icon-magnifier icon-input-custom"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0 table-responsive">
        <table class="table table-bordered table-hover">
          <thead>
            <tr class="font-weight-bold">
              <th class="text-center text-nowrap align-middle" rowspan="2">Instructor Name</th>
              <th class="text-center align-middle" rowspan="2">Base Club</th>
              <th class="text-center align-middle" colspan="2">Studio 1</th>
              <th class="text-center align-middle" colspan="2">Studio 2</th>
              <th class="text-center align-middle" colspan="2">Cycling</th>
              <th class="text-center align-middle" colspan="2">Gymfloor</th>
              <th class="text-center align-middle" colspan="2">Team Teach</th>
              <th class="text-center align-middle" rowspan="2">Total Class Conduct</th>
              <th class="text-center align-middle" rowspan="2">Total Commision</th>
            </tr>
            <tr>
              <th class="text-center align-middle">Total Class</th>
              <th class="text-center align-middle">Commision</th>
              <th class="text-center align-middle">Total Class</th>
              <th class="text-center align-middle">Commision</th>
              <th class="text-center align-middle">Total Class</th>
              <th class="text-center align-middle">Commision</th>
              <th class="text-center align-middle">Total Class</th>
              <th class="text-center align-middle">Commision</th>

              <th class="text-center align-middle">Total Class</th>
              <th class="text-center align-middle">Commision</th>
            </tr>
            <!-- <tr>
              <th class="text-center align-middle">Total Class</th>
              <th class="text-center align-middle">Commision</th>
            </tr>
            <tr>
              <th class="text-center align-middle">Total Class</th>
              <th class="text-center align-middle">Commision</th>
            </tr>
            <tr>
              <th class="text-center align-middle">Total Class</th>
              <th class="text-center align-middle">Commision</th>
            </tr> -->
          </thead>
          <tbody>
            <template v-for="data in items">
              <tr :key="data.id" class="align-middle">
                <td class="text-center">{{ data.coaches_name }}</td>
                <td class="text-center">{{ data.club }}</td>
                <td class="text-center">{{ data.studio_1_class }}</td>
                <td class="text-center">{{ formatNumber(data.studio_1_comm) }}</td>
                <td class="text-center">{{ data.studio_2_class }}</td>
                <td class="text-center">{{ formatNumber(data.studio_2_comm) }}</td>
                <td class="text-center">{{ data.cycling_class }}</td>
                <td class="text-center">{{ formatNumber(data.cycling_comm) }}</td>
                <td class="text-center">{{ data.gym_floor_class }}</td>
                <td class="text-center">{{ formatNumber(data.gym_floor_comm) }}</td>
                <td class="text-center">{{ data.team_teach_class }}</td>
                <td class="text-center">{{ formatNumber(data.team_teach_comm) }}</td>
                <td class="text-center">{{ data.total_class }}</td>
                <td class="text-center">{{ formatNumber(data.total_comm) }}</td>
              </tr>
            </template>
          </tbody>
        </table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage" :total-pages="totalPage"
          @page-changed="pageOneChanged" prev-text="Prev" next-text="Next" />
      </div>
    </div>

    <b-modal size="lg" modal-class="modal-custom-input" hide-footer :ref="'edit_history'" title="Edit">
      <form @submit.prevent="validateRegister">
        <b-row class="mb-20">
          <b-col sm="2">
            <label for="status">Classes Name</label>
          </b-col>
          <b-col sm="10">
            <b-form-select name="classes_name" v-validate="'required'" v-model="editData.classes_id">
              <option :value="null">Please select</option>
              <option v-for="item in optClasses" :key="item.id" :value="item.id">{{ item.name }}</option>
            </b-form-select>
            <span class="error">{{ errors.first('classes_name') }}</span>
          </b-col>
        </b-row>
        <b-row class="mb-20">
          <b-col sm="2">
            <label for="status">Instructor</label>
          </b-col>
          <b-col sm="10">
            <b-form-select name="coaches" v-validate="'required'" v-model="editData.coaches_id">
              <option :value="null">Please select</option>
              <option v-for="item in optCoaches" :key="item.id" :value="item.id">{{ item.name }}</option>
            </b-form-select>
            <span class="error">{{ errors.first('coaches') }}</span>
          </b-col>
        </b-row>

        <b-row class="mb-20">
          <b-col sm="2">
            <label>Class Number Booking</label>
          </b-col>
          <b-col sm="10">
            <b-form-input v-model="editData.number_booking" name="class_number_booking" v-validate="'numeric'"
              type="text"></b-form-input>
            <span class="error">{{ errors.first('class_number_booking') }}</span>
          </b-col>
        </b-row>

        <b-row class="mb-20">
          <b-col sm="2">
            <label>Class Waiting List</label>
          </b-col>
          <b-col sm="10">
            <b-form-input v-model="editData.number_waiting_list" name="number_waiting_list" v-validate="'numeric'"
              type="text"></b-form-input>
            <span class="error">{{ errors.first('number_waiting_list') }}</span>
          </b-col>
        </b-row>

        <b-row class="mb-20">
          <b-col sm="2">
            <label>Class Number Show</label>
          </b-col>
          <b-col sm="10">
            <b-form-input v-model="editData.number_show" name="number_show" v-validate="'numeric'"
              type="text"></b-form-input>
            <span class="error">{{ errors.first('number_show') }}</span>
          </b-col>
        </b-row>

        <b-row class="mb-20">
          <b-col sm="2">
            <label>Commission</label>
          </b-col>
          <b-col sm="10">
            <b-form-input v-model="editData.commision" name="commission" v-validate="'numeric'"
              type="text"></b-form-input>
            <span class="error">{{ errors.first('commission') }}</span>
          </b-col>
        </b-row>

        <hr>
        <div>Cover Instructor & Class</div>
        <hr class="short-line left mb-20">

        <b-row class="mb-20">
          <b-col sm="2">
            <label for="status">Cover Instructor</label>
          </b-col>
          <b-col sm="10">
            <b-form-select name="cover_coaches" v-model="editData.cover_coaches_id">
              <option :value="null">Please select</option>
              <option v-for="item in optCoaches" :key="item.id" :value="item.id">{{ item.name }}</option>
            </b-form-select>
            <!-- <span class="error">{{ errors.first('coaches') }}</span> -->
          </b-col>
        </b-row>

        <b-row class="mb-20">
          <b-col sm="2">
            <label for="status">Cover Class</label>
          </b-col>
          <b-col sm="10">
            <b-form-select name="cover_classes_name" v-model="editData.cover_classes_id">
              <option :value="null">Please select</option>
              <option v-for="item in optClasses" :key="item.id" :value="item.id">{{ item.name }}</option>
            </b-form-select>
            <!-- <span class="error">{{ errors.first('classes_name') }}</span> -->
          </b-col>
        </b-row>

        <hr>
        <div class="text-right">
          <button type="submit" class="btn-primary">Submit</button>
        </div>
      </form>
    </b-modal>

    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="40" alt="">
        <br>
        <div class="title-loading color-white">Please wait...</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import Pagination from '@/views/component/pagination'
import moment from 'moment'

export default {
  name: 'classAttendance',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      loadingActive: false,
      fields: [

        {
          key: 'branch',
          label: 'Branch',
          sortable: true
        },
        {
          key: 'studio',
          label: 'studio',
          sortable: true
        },
        {
          key: 'class_date',
          label: 'Class Date',
          sortable: true
        },
        {
          key: 'time_start',
          label: 'Time',
          sortable: false
        },
        {
          key: 'classes',
          label: 'Classes',
          sortable: false
        },
        {
          key: 'coaches',
          label: 'Coaches',
          sortable: false
        },
        {
          key: 'cover_classes',
          label: 'Cover Classes',
          sortable: false
        },
        {
          key: 'cover_coaches',
          label: 'Cover Coaches',
          sortable: false
        },

        {
          key: 'total_seat',
          label: 'Total seat',
          sortable: false
        },
        {
          key: 'number_booking',
          label: 'Class Number Booking',
          sortable: false
        },
        {
          key: 'number_waiting_list',
          label: 'Class Waiting List',
          sortable: false
        },
        {
          key: 'number_show',
          label: 'Class Number Show',
          sortable: false
        },
        {
          key: 'matrix_persen',
          label: 'Matrix (%)',
          sortable: false,
          formatter: (value, key, item) => {
            return Math.round((item.matrix_persen) * 100) + '%'
          }
        },
        {
          key: 'commision',
          label: 'Commision',
          formatter: (value, key, item) => {
            return 'Rp. ' + parseFloat(item.commision).toLocaleString('id-ID', { maximumFractionDigits: 2 })
          },
          sortable: false
        },
        {
          key: 'actions',
          label: 'Actions',
          sortable: false
        }
      ],
      items: [],
      optClasses: [],
      optCoaches: [],
      dataBranch: [],
      optStudio: [],
      branch_id: null,
      changeStudio: null,
      exportDates: (moment().startOf('month').format('YYYY-MM-DD')) + ' to ' + (moment().endOf('month').format('YYYY-MM-DD')),
      exportConfig: {
        mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d/m/y",
        defaultDate: [(moment().startOf('month').format('YYYY-MM-DD')), (moment().endOf('month').format('YYYY-MM-DD'))]
      },
      sortType: '',
      sortBy: '',
      searchData: '',
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      editData: {
        classes_id: null,
        coaches_id: null,
        cover_classes_id: null,
        cover_coaches_id: null,
        number_booking: 0,
        number_waiting_list: 0,
        number_show: 0,
        commision: 0
      },
      selectedData: {}
    }
  },
  computed: {
    name() {
      return this.$route.name
    }
  },
  methods: {
    validateRegister() {
      this.loadingActive = true
      console.log(this.editData)
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.editData.number_waiting_list = Number(this.editData.number_waiting_list)
          this.editData.number_booking = Number(this.editData.number_booking)
          this.editData.number_show = Number(this.editData.number_show)
          this.editData.commision = Number(this.editData.commision)
          axios.put('fitness/v1/classes_schedule_history/' + this.selectedData.id, this.editData).then(response => {
            this.hideModal('edit_history')
            this.loadingActive = false
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
            this.fetchData()
          }).catch(error => {
            this.loadingActive = false
            console.log('error log', error)
          })

        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    showModal(id, item) {
      console.log(item)
      this.selectedData = item
      this.editData.classes_id = item.classes_id
      this.editData.coaches_id = item.coaches_id
      this.editData.cover_coaches_id = item.cover_coaches_id
      this.editData.cover_classes_id = item.cover_classes_id
      this.editData.number_booking = item.number_booking
      this.editData.number_waiting_list = item.number_waiting_list
      this.editData.number_show = item.number_show
      this.editData.commision = item.commision
      this.$refs[id].show()

      axios.get('fitness/v1/classes?sorting=name&sorting_type=asc&studio_id=' + item.studio_id).then(response => {
        this.optClasses = response.data.data.rows
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })

      axios.get('fitness/v1/coaches?status=active&sorting=name&sorting_type=asc').then(response => {
        this.optCoaches = response.data.data.rows
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
    },
    hideModal(id) {
      this.$refs[id].hide()
    },
    changeDateBooking(selectedDates, dateStr, instance) {
      // console.log('test2', dateStr)
      if (selectedDates.length === 2) {
        if (typeof selectedDates[0] === typeof selectedDates[1]) {
          this.exportDates = dateStr + ' to ' + dateStr
        } else {
          this.exportDates = dateStr
        }
        if (this.exportDates.includes(" to ") === true) {
          this.fetchData()
        }
      }
    },
    parseDate(value) {
      return moment(value).format('DD-MM-YYYY')
    },
    parseTime(value) {
      return (value).slice(0, -3)
    },
    pageOneChanged(pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    sortingChanged(event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
        // console.log(this.sortType)
      } else {
        this.sortType = 'desc'
        // console.log(this.sortType)
      }
      this.fetchData()
    },
    enterClicked(searchEvent) {
      this.fetchData()
    },
    getBadge(status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    parseImg(value) {
      return Auth.apiUrl + 'fitness/v1/img/member/' + value
    },
    getRowCount(items) {
      return items.length
    },
    openPage(event) {
      this.$router.push(event)
    },
    editBlogCategory(event) {
      this.$router.push(event)
    },
    changeBranch(event) {
      this.changeStudio = null
      axios.get('fitness/v1/studio?sorting=id&sorting_type=asc&branch_id=' + event).then(response => {
        this.optStudio = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })

      let cutDate = this.exportDates.split(' to ')
      let url = 'crm/v1/group_fitness/best_of_the_best?page=' + this.currentPage
        + '&limit=' + this.paginationLimit
        + '&sorting=' + this.sortBy
        + '&sorting_type=' + this.sortType
        + '&keyword=' + this.searchData
        + '&start_date=' + cutDate[0]
        + '&end_date=' + cutDate[1]

      if (event != null) {
        url += '&branch_id=' + event
      }

      if (this.changeStudio != null) {
        url += '&studio_id=' + this.changeStudio
      }

      axios.get(url).then(response => {
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
      }).catch(error => {
        console.log('error', error)
      })
    },
    formatNumber(event) {
      var data = parseInt(event)
      return data.toLocaleString('id-ID', { maximumFractionDigits: 0 })
    },
    changeStudioSelect(event) {
      let cutDate = this.exportDates.split(' to ')
      let url = 'fitness/v1/report/group_fitness?page=' + this.currentPage
        + '&limit=' + this.paginationLimit
        + '&sorting=' + this.sortBy
        + '&sorting_type=' + this.sortType
        + '&keyword=' + this.searchData
        + '&start_date=' + cutDate[0]
        + '&end_date=' + cutDate[1]

      if (event != null) {
        url += '&studio_id=' + event
      }

      if (this.branch_id != null) {
        url += '&branch_id=' + this.branch_id
      }

      axios.get(url).then(response => {
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
      }).catch(error => {
        console.log('error', error)
      })
    },
    fetchData() {
      this.loadingActive = true
      let cutDate = this.exportDates.split(' to ')
      let url = 'crm/v1/group_fitness/best_of_the_best?page=' + this.currentPage
        + '&limit=' + this.paginationLimit
        + '&sorting=' + this.sortBy
        + '&sorting_type=' + this.sortType
        + '&keyword=' + this.searchData
        + '&start_date=' + cutDate[0]
        + '&end_date=' + cutDate[1]

      if (this.changeStudio != null) {
        url += '&studio_id=' + this.changeStudio
      }
      if (this.branch_id != null) {
        url += '&branch_id=' + this.branch_id
      }

      axios.get(url).then(response => {
        this.loadingActive = false
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
      }).catch(error => {
        this.loadingActive = false
        console.log('error', error)
      })

      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    },
    exportClass() {
      let dates = this.exportDates.split(' to ')
      let url = 'crm/v1/export/group_fitness/best_of_the_best?start_date=' + dates[0]
        + '&end_date=' + dates[1]
        + '&keyword=' + this.searchData

      if (this.branch_id != null) {
        url += '&branch_id=' + this.branch_id
      }

      axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      }).then(response => {
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })

        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Group Fitness BOTB Report ' + moment(dates[0]).format('DD MMM YYYY') + ' - ' + moment(dates[1]).format('DD MMM YYYY') + '.xlsx'
        link.click()
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created() {
    this.fetchData()
  }
}
</script>

<style></style>
